/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Workout_Highlights_Matched_WhenInputs */

const en_us2_workout_highlights_matched_when = /** @type {(inputs: Workout_Highlights_Matched_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`on ${i?.date}`)
};

const pt_br2_workout_highlights_matched_when = /** @type {(inputs: Workout_Highlights_Matched_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`em ${i?.date}`)
};

const es_419_workout_highlights_matched_when = /** @type {(inputs: Workout_Highlights_Matched_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`el ${i?.date}`)
};

const pt_pt2_workout_highlights_matched_when = /** @type {(inputs: Workout_Highlights_Matched_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`em ${i?.date}`)
};

const fr_fr2_workout_highlights_matched_when = /** @type {(inputs: Workout_Highlights_Matched_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`le ${i?.date}`)
};

const de_de2_workout_highlights_matched_when = /** @type {(inputs: Workout_Highlights_Matched_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`am ${i?.date}`)
};

const it_it2_workout_highlights_matched_when = /** @type {(inputs: Workout_Highlights_Matched_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`il ${i?.date}`)
};

/**
* | output |
* | --- |
* | "on {date}" |
*
* @param {Workout_Highlights_Matched_WhenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_highlights_matched_when = /** @type {((inputs: Workout_Highlights_Matched_WhenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Highlights_Matched_WhenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_highlights_matched_when(inputs)
	if (locale === "es-419") return es_419_workout_highlights_matched_when(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_highlights_matched_when(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_highlights_matched_when(inputs)
	if (locale === "de-DE") return de_de2_workout_highlights_matched_when(inputs)
	if (locale === "it-IT") return it_it2_workout_highlights_matched_when(inputs)
	return en_us2_workout_highlights_matched_when(inputs)
});
export { workout_highlights_matched_when as "workout-highlights.matched_when" }